class BOTBProductForm extends HTMLFormElement {
    constructor() {
        super();
        this.product_available = (this.getAttribute('available') == 'true') ? true : false;  
        this.selling_plan_data = this.querySelector('#selling-plan-json') ? JSON.parse(this.querySelector('#selling-plan-json').innerText) : null;
        this.variant_data = this.querySelector('#variant-json') ? JSON.parse(this.querySelector('#variant-json').innerText) : null;
        console.log(this.selling_plan_data, this.variant_data);
        this.current_selling_plan_id = this.querySelector('select[name="selling_plan_id"]') ? this.querySelector('select[name="selling_plan_id"]').value : null;
        this.current_variant_id = this.querySelector('input[name="id"]:checked') ? this.querySelector('input[name="id"]:checked').value : this.querySelector('[type="hidden"][name="id"]').value;
        this.showCurrency = this.getAttribute('show-currency') === 'true' ? true : false;
        this.productCurrency = this.getAttribute('product-currency');

        this.addEventListener('change', (event) => {
            if(this.product_available) {
              this.current_variant_id = this.querySelector('input[name="id"]:checked') ? this.querySelector('input[name="id"]:checked').value : this.current_variant_id;
              if(event.target.name == 'selling_plan') {
                  if(event.target.value == 'true') this.current_selling_plan_id = this.querySelector('select[name="selling_plan_id"]').value;
              } else {
                  this.renderPrices();
              }
  
              if(event.target.name == 'selling_plan' || event.target.name == 'id') {
                  this.renderButtonText();
                  this.renderPricePerEach();
              }
  
              if(event.target.name == 'id') {
                  window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.current_variant_id}`);
              }
            }
        });

        this.addEventListener('submit', this.addToCart.bind(this));
    }

    connectedCallback() {
        if(this.product_available) {
            this.renderPrices();
            this.renderButtonText();
            this.renderPricePerEach();
        }
    }

    currentPrices() {
        const variant = this.variant_data.find(variant => variant.id == this.current_variant_id);
        const selling_plan = this.selling_plan_data.find(selling_plan => selling_plan.id == this.current_selling_plan_id);
        this.current_selling_plan = selling_plan;
        console.log(variant, selling_plan);

        if(selling_plan.price_adjustments[0].value_type == "percentage") {
            const discounted_price = variant.price * (100 - selling_plan.price_adjustments[0].value) / 100;
            return {
                price: discounted_price,
                compare_at_price: variant.price,
                onetime_price: variant.price,
                onetime_compare_at_price: variant.compare_at_price
            }
        } else {
            return {
                price: variant.price,
                compare_at_price: '',
                onetime_price: variant.price,
                onetime_compare_at_price: variant.compare_at_price
            }
        }
    }

    renderPrices() {
        const prices = this.currentPrices();

        // Needed for the ATC button
        this.currentPrice = Shopify.formatMoney(this.currentPrices().price);
        this.onetimePrice = Shopify.formatMoney(this.currentPrices().onetime_price);

        // Subscription normal price
        this.querySelector('.botb-main-product__selling-plan--subscription .botb-rc-widget__price').innerText = Shopify.formatMoney(prices.price);
        // Subscription compare at price
        this.querySelector('.botb-main-product__selling-plan--subscription .botb-rc-widget__compare-at-price').innerHTML = prices.compare_at_price > 0 && prices.compare_at_price > prices.price ? '<span>' + Shopify.formatMoney(prices.compare_at_price) + '</span>' : '';
        // One time normal price
        this.querySelector('.botb-main-product__selling-plan--one-time .botb-rc-widget__price').innerText = Shopify.formatMoney(prices.onetime_price);
        // One time compare at price
        this.querySelector('.botb-main-product__selling-plan--one-time .botb-rc-widget__compare-at-price').innerText = prices.onetime_compare_at_price > 0 && prices.onetime_compare_at_price > prices.onetime_price ? Shopify.formatMoney(prices.onetime_compare_at_price) : '';

        if(this.showCurrency) {
            const selectors = [
                '.botb-main-product__selling-plan--subscription .botb-rc-widget__price', 
                '.botb-main-product__selling-plan--one-time .botb-rc-widget__price'
            ];
            selectors.forEach(selector => {
                if(this.querySelector(selector).innerText != '') this.querySelector(selector).innerHTML += ` <span class="currency-code">${this.productCurrency}</span>`;
            })
            
        }
    }

    renderButtonText() {
        this.querySelector('.botb-main-product__atc:not(.botb-main-product__atc--sold-out) span').innerText = (this.querySelector('input[name="selling_plan"]:checked').value == 'true') ? `Subscribe Now | ${this.currentPrice}/mo` : `Add to Cart | ${this.onetimePrice}`;
    }

    renderPricePerEach() {
        this.querySelectorAll('.botb-main-product__variant').forEach((variant_element) => {
            const pack_size = variant_element.dataset.packSize;
            
            if(pack_size) {

                const variant_id = variant_element.querySelector('input[name="id"]').value;
                const variant = this.variant_data.find(variant => variant.id == variant_id); 
                
                if(variant.available) {
                    const subscription_on = (this.querySelector('input[name="selling_plan"]:checked').value == 'true');
                    const variant_price_with_discount = (subscription_on) ? variant.price * (100 - this.current_selling_plan.price_adjustments[0].value) / 100 : variant.price;
                    const price_per_each = variant_price_with_discount / pack_size;
                    variant_element.querySelector('.botb-rc-widget__pack-price').innerText = `${Shopify.formatMoney(price_per_each)}/each`;
                }
            }
        });
    }

    addToCart(evt) {
        evt.preventDefault();

        const button = this.querySelector('button[type="submit"]');

        this.current_variant_id = this.querySelector('input[name="id"]:checked') ? this.querySelector('input[name="id"]:checked').value : this.querySelector('[type="hidden"][name="id"]').value;
        this.current_selling_plan_id = (this.querySelector('input[name="selling_plan"]:checked') && this.querySelector('input[name="selling_plan"]:checked').value == 'true') ? this.querySelector('select[name="selling_plan_id"]').value : null;
        
        const formData = {
            items: [
                {
                    id: this.current_variant_id,
                    quantity: 1
                }
            ]
        };
        if(this.current_selling_plan_id) formData.items[0].selling_plan = this.current_selling_plan_id;

        HELPER_UTIL.fetchData({
            method: 'POST',
            config: {
                headers: {
                        'Content-Type': 'application/json'
                    },
            },
            url: `${window.Shopify.routes.root}cart/add.js?sections=${HELPER_UTIL.sectionRenderUtil('cart-drawer').getSectionsString()}`,
            data: JSON.stringify(formData),
            onsuccess: (data) => {
                const cartDrawer = document.querySelector('cart-drawer-component');
                // Render Cart Drawer with data
                if (cartDrawer) {
                    HELPER_UTIL.dispatchCustomEvent(
                        _EVENT_HELPER.triggerCartChange,
                        button,
                        {
                            productVariant: data.variant_id,
                            sections: data.sections,
                        }
                    );
                    HELPER_UTIL.dispatchCustomEvent(
                        _EVENT_HELPER.showDrawer,
                        document,
                        {
                            drawerType: 'cart-drawer',
                        }
                    );
                    console.log(data);
                } else {
                    window.location.href = `${Shopify.routes.root}cart`;
                }
            },
            onerror: (error) => {
                console.log(error);
                if (error.json) {
                    error.json().then((errorObj) => {
                        if (errorObj.status === 422) {
                             // variant add to cart errors
                             HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.triggerVariantAddToCartError, document, {
                                errorObj: errorObj.description,
                            });
                            // Show gift card errors
                            if (
                                errorObj.description.hasOwnProperty('email') ||
                                errorObj.description.hasOwnProperty('send_on')
                            ) {
                                HELPER_UTIL.dispatchCustomEvent(
                                    _EVENT_HELPER.triggerProductGiftCardError,
                                    this,
                                    {
                                        errorObj: errorObj.description,
                                    }
                                );
                              
                            } else {
                                console.log('error');
                                alert('error');
                            }
                        }
                    });
                } else {
                    HELPER_UTIL.dispatchCustomEvent(
                        _EVENT_HELPER.triggerToastMessage,
                        document,
                        {
                            toastType: 'common-errors',
                            messageType: 'error',
                            message:
                                'Something went went wrong! Please try again',
                        }
                    );
                }
            }
        });
    }

}

customElements.define("botb-product-form", BOTBProductForm, { extends: "form" });